Px.Editor.MobileToolbar = class MobileToolbar extends Px.Editor.BaseComponent {

  template() {
    const store = this.data.store;
    const r = this.renderChild;
    return Px.template`
      <div class="px-mobile-toolbar">
        ${Px.if(!(store.project.loaded && store.theme.loaded) || store.ui.share_view, () => {
          return Px.template`<div class="px-tabs"></div>`;
        }).elseIf(store.mobile.view_mode === 'layout-selection', () => {
          return Px.template`
            <div class="px-mobile-tool">
              ${r(this.toolComponent, 'editor-tool-page-layout-selector')}
            </div>
            <div class="px-tabs"></div>
          `;
        }).elseIf(store.mobile.view_mode === 'autofill', () => {
          return Px.template`
            <div class="px-mobile-tool">
              ${r(this.toolComponent, `editor-tool-${store.mobile.active_tool}`, {})}
            </div>
            <div class="px-tabs">
              <div class="px-notice">
                ${Px.t('Select images from available sources')}
              </div>
            </div>
          `;
        }).elseIf(store.mobile.view_mode === 'cut-prints-quantity-selection', () => {
          return Px.template`
            <div class="px-mobile-tool">
              ${r(this.toolComponent, `editor-tool-${store.mobile.active_tool}`, {})}
            </div>
            <div class="px-tabs">
              <p class="px-notice">
                  ${Px.if(store.cut_prints.selected_sets.length > 0, () => {
                    return Px.t('Adjust the quantity of selected photos');
                  }).else(() => {
                    return Px.t('Select photos to adjust quantity');
                  })}
                </p>
              </p>
            </div>
          `;
        }).elseIf(store.mobile.view_mode === 'set-selection', () => {
          const increments = store.theme.page_increments;
          if (increments === store.mobile.selected_page_count) {
            return Px.template`
              <div class="px-tabs">
                <button class="px-tab" data-onclick="duplicatePageSets">
                  <div class="px-icon">${Px.raw(MobileToolbar.icons.duplicate)}</div>
                  <div class="px-title">${Px.t('Duplicate')}</div>
                </button>
                <button class="px-tab px-danger" data-onclick="deletePageSets">
                  <div class="px-icon">${Px.raw(MobileToolbar.icons.remove)}</div>
                  <div class="px-title">${Px.t('Delete')}</div>
                </button>
              </div>
            `;
          } else {
            return Px.template`
              <div class="px-tabs">
                <p class="px-notice">
                  ${Px.t('Select {{count}} pages to remove or duplicate').replace('{{count}}', increments)}
                </p>
              </div>
            `;
          }
        }).elseIf(store.mobile.view_mode === 'page', () => {
          const set = store.selected_set;
          return Px.template`
            <div class="px-page-captions">
              ${Px.if(set.left_caption, () => {
                return Px.template`
                  <div class="px-page-caption">${set.left_caption}</div>
                `;
              })}
              ${Px.if(this.centerCaption, () => {
                return Px.template `
                  <div class="px-page-caption">${this.centerCaption}</div>
                `;
              })}
              ${Px.if(set.right_caption, () => {
                return Px.template`
                  <div class="px-page-caption">${set.right_caption}</div>
                `;
              })}
            </div>
            <div class="px-tabs">
              ${Px.if(store.cut_print_mode, () => {
                return this.tabs.map(tab => {
                  return Px.template`
                    <button class="px-tab ${tab.danger ? 'px-danger' : ''}"
                            data-id="${tab.id}"
                            data-selected="${Boolean(tab.tool_id  && store.mobile.active_tool === tab.tool_id)}"
                            data-onclick="onTabClick">
                      <div class="px-icon">${Px.raw(tab.icon)}</div>
                      <div class="px-title">${tab.title}</div>
                    </button>
                  `;
                });
              }).else(() => {
                let notice_text = Px.t('Select element to edit');
                if (store.skip_mobile_project_mode && Px.config.autofill_button) {
                  const autofill_button = Px.template`
                    <button class="px-autofill-button" data-onclick="openAutofillPanel">
                      ${Px.t('autofill images')}
                    </button>
                  `;
                  const notice_template = Px.t('Select element to edit or {{autofill_button}}');
                  notice_text = notice_template.replace('{{autofill_button}}', autofill_button);
                }
                return Px.template`
                  <div class="px-tabs">
                    <p class="px-notice">
                      ${Px.raw(notice_text)}
                    </p>
                  </div>
                `;
              })}
            </div>
          `;
        }).elseIf(store.selected_element || store.cut_print_mode, () => {
          return Px.template`
            ${Px.if(this.toolComponent, () => {
              return Px.template`
                <div class="px-mobile-tool">
                  ${r(this.toolComponent, `editor-tool-${store.mobile.active_tool}`, {})}
                </div>
              `;
            })}
            <div class="px-tabs">
              ${Px.if(store.cut_print_mode && this.cutPrintCount === 0, () => {
                return Px.template`
                  <div class="px-tabs">
                    <p class="px-notice">
                      ${Px.t('Select an image source to begin.')}
                    </p>
                  </div>
                `;
              }).else(() => {
                return this.tabs.map(tab => {
                  return Px.template`
                    <button class="px-tab ${tab.danger ? 'px-danger' : ''}"
                            data-id="${tab.id}"
                            data-selected="${Boolean(tab.tool_id  && store.mobile.active_tool === tab.tool_id)}"
                            data-onclick="onTabClick">
                      <div class="px-icon">${Px.raw(tab.icon)}</div>
                      <div class="px-title">${tab.title}</div>
                    </button>
                  `;
                });
              })}
            </div>
          `;
        }).else(() => {
          let notice_text = Px.t('Select page to edit');
          if (Px.config.autofill_button) {
            const autofill_button = Px.template`
              <button class="px-autofill-button" data-onclick="openAutofillPanel">
                ${Px.t('autofill images')}
              </button>
            `;
            const notice_template = Px.t('Select page to edit or {{autofill_button}}');
            notice_text = notice_template.replace('{{autofill_button}}', autofill_button);
          }
          return Px.template`
            <div class="px-tabs">
              <p class="px-notice">
                ${Px.raw(notice_text)}
              </p>
            </div>
          `;
        })}
      </div>
    `;
  }

  constructor(data) {
    super(data);
    this.selectFirstImage = this.selectFirstImage.bind(this);
    this.selectFirstText = this.selectFirstText.bind(this);

    const store = this.data.store;

    mobx.when(() => store.project.loaded && store.theme.loaded, () => {
      if (store.cut_print_mode && this.cutPrintCount === 0) {
        store.mobile.setActiveTool('image-source-editor');
      }
    });
  }

  get dataProperties() {
    return {
      store: {required: true}
    };
  }

  static get properties() {
    return {
      active_tab: {type: 'str', std: null},
      selected_element: {type: 'ref', std: null},
      is_tab_closing: {type: 'bool', std: false},
      is_tab_opening: {type: 'bool', std: false}
    };
  }

  static get computedProperties() {
    return {
      tabs: function() {
        let tabs = [];
        if (this.data.store.cut_print_mode) {
          tabs = this.cutPrintTabs;
        } else {
          tabs = this.regularTabs;
        }
        return tabs.filter(tab => !tab.hidden);
      },
      cutPrintTabs: function() {
        const default_icons = Px.Editor.Main.icons;
        const store = this.data.store;
        let tabs = [];
        if (store.selected_set) {
          const image_element = store.selected_page.image_elements.find(image => image.edit);
          tabs = [
            {
              id: 'image->cropping',
              icon: MobileToolbar.icons.crop,
              title: Px.t('Cropping'),
              tool_id: 'image-crop-editor',
              activate: cb => {
                mobx.runInAction(() => {
                  store.mobile.animate(() => {
                    if (image_element) {
                      store.selectElement(image_element);
                    }
                    cb();
                  }) ;
                });
              }
            },
            {
              id: 'cut-print->delete',
              icon: MobileToolbar.icons.remove,
              title: Px.t('Delete'),
              danger: true,
              activate: () => {
                if (confirm(Px.t('Are you sure you want to delete this photo?'))) {
                  store.mobile.animate(() => {
                    mobx.runInAction(() => {
                      store.deleteSets([store.selected_set]);
                      store.mobile.setActiveTool(null);
                    });
                  });
                }
              }
            }
          ];
          if (image_element && image_element.emask && store.masks.images.length) {
            tabs.splice(1, 0, {
              id: 'image->mask',
              icon: MobileToolbar.icons.image_mask,
              title: Px.t('Mask'),
              tool_id: 'image-mask-editor',
              activate: cb => {
                if (image_element) {
                  store.selectElement(image_element);
                }
                if (store.ui.element_cropping_mode) {
                  store.mobile.animate(cb)
                } else {
                  cb();
                }
              }
            });
          }
        } else {
          tabs = [
            {
              id: 'cut-prints->images',
              icon: MobileToolbar.icons.image,
              title: Px.t('Add More Images'),
              tool_id: 'image-source-editor',
              activate: (cb) => {
                if (store.mobile.active_tool === 'image-source-editor') {
                  store.mobile.setActiveTool(null);
                } else {
                  cb();
                }
              }
            },
            {
              id: 'cut-prints->quantities',
              icon: MobileToolbar.icons.quantity_controls,
              title: Px.t('Adjust Quantities'),
              tool_id: 'cut-prints-quantity-editor'
            }
          ];
        }
        return tabs;
      },
      regularTabs: function() {
        const default_icons = Px.Editor.Main.icons;
        const store = this.data.store;
        const selected_element = store.selected_element;
        let tabs = [];
        if (selected_element) {
          if (selected_element.type === 'image') {
            tabs = [];
            if (selected_element.replace) {
              tabs.push({
                id: 'image->source',
                icon: MobileToolbar.icons.image,
                title: Px.t('Image'),
                tool_id: 'image-source-editor',
                activate: cb => store.ui.element_cropping_mode ? store.mobile.animate(cb) : cb()
              });
            }
            if (selected_element.crop) {
              tabs.push({
                id: 'image->cropping',
                icon: MobileToolbar.icons.crop,
                title: Px.t('Cropping'),
                tool_id: 'image-crop-editor',
                activate: cb => store.mobile.animate(cb)
              });
            }
            if (selected_element.emask && store.masks.images.length) {
              tabs.push({
                id: 'image->mask',
                icon: MobileToolbar.icons.image_mask,
                title: Px.t('Mask'),
                tool_id: 'image-mask-editor',
                activate: cb => store.ui.element_cropping_mode ? store.mobile.animate(cb) : cb()
              });
            }
          } else if (selected_element.type === 'text') {
            tabs = [
              {
                id: 'text->text',
                icon: MobileToolbar.icons.text,
                title: Px.t('Text'),
                tool_id: 'text-content-editor'
              },
              {
                id: 'text->alignment',
                icon: MobileToolbar.icons.alignment,
                title: Px.t('Alignment'),
                tool_id: 'text-alignment-editor'
              },
              {
                id: 'text->font',
                icon: MobileToolbar.icons.font,
                title: Px.t('Font'),
                tool_id: 'text-font-editor'
              }
            ];
            if (selected_element.efontsize) {
              tabs.push({
                id: 'text->fontsize',
                icon: MobileToolbar.icons.font_size,
                title: Px.t('Size'),
                tool_id: 'text-size-editor'
              });
            }
          }
        }
        return tabs;
      },
      toolComponent: function() {
        const components = {
          'page-layout-selector': Px.Editor.MobileLayoutsPanel,
          'image-source-editor': Px.Editor.MobileImageSourcePanel,
          'image-crop-editor': Px.Editor.MobileImageCropPanel,
          'image-mask-editor': Px.Editor.MobileImageMaskPanel,
          'text-content-editor': Px.Editor.MobileTextContentPanel,
          'text-alignment-editor': Px.Editor.MobileTextAlignmentPanel,
          'text-font-editor': Px.Editor.MobileTextFontPanel,
          'text-size-editor': Px.Editor.MobileTextSizePanel,
          'autofill-panel': Px.Editor.MobileImageSourcePanel,
          'cut-prints-quantity-editor': Px.Editor.MobileCutPrintQuantityPanel
        };
        return components[this.data.store.mobile.active_tool] || null;
      },
      cutPrintCount: function() {
        return this.data.store.project.cut_print_sets_with_definitions.length;
      },
      centerCaption: function() {
        const store = this.data.store;
        const set = store.selected_set;
        if (store.cut_print_mode && !set.left_caption && !set.center_caption && !set.right_caption) {
          const image_element = set.pages[0].image_elements.find(e => e.is_editable_master_element && e.id);
          if (image_element) {
            const image = store.images.get(image_element.id);
            if (image && image.filename) {
              return image.filename;
            }
          }
        }
        return set.center_caption;
      }
    };
  }

  getTab(tab_id) {
    return this.tabs.find(tab => tab.id === tab_id);
  }

  // --------------
  // Event handlers
  // --------------

  onTabClick(evt) {
    const tab_id = evt.currentTarget.getAttribute('data-id');
    const tab = this.getTab(tab_id);
    if (tab.activate) {
      tab.activate(() => {
        if (tab.tool_id) {
          this.data.store.mobile.setActiveTool(tab.tool_id);
        }
      });
    } else if (tab.tool_id) {
      this.data.store.mobile.setActiveTool(tab.tool_id);
    }
  }

  selectFirstImage() {
    const store = this.data.store;
    const image = this.getEditableElements('image')[0];
    if (!image) {
      store.showNotification(Px.t('No editable images on selected page'), 'warning');
    } else {
      store.selectElement(image);
    }
  }

  selectFirstText() {
    const store = this.data.store;
    const text = this.getEditableElements('text')[0];
    if (!text) {
      store.showNotification(Px.t('No editable text on selected page'), 'warning');
    } else {
      store.selectElement(text);
    }
  }

  openLayoutsPanel() {
    const store = this.data.store;
    const layouts = store.layouts.layouts.filter(layout => layout.applicableToPage(store.selected_page, store.options));
    if (layouts.length === 0) {
      store.showNotification(Px.t('No layouts available for the selected page'), 'warning');
    } else {
      store.mobile.setActiveTool('layouts');
    }
  }

  duplicatePageSets(evt) {
    const store = this.data.store;
    if (!store.project.can_add_pages) {
      store.showNotification(Px.t('Cannot add any more pages to this project.'), 'warning');
      return;
    }
    mobx.runInAction(() => {
      store.duplicateSets(store.mobile.selected_sets);
      store.mobile.selected_sets.clear();
      store.showNotification(Px.t('Pages duplicated'), 'success');
    });
  }

  deletePageSets(evt) {
    const store = this.data.store;
    if (!store.project.can_delete_pages) {
      store.showNotification(Px.t('Cannot remove any more pages from this project.'), 'warning');
      return;
    }
    this.makeModal(Px.Editor.MobileToolbar.DeletePageSetsModal, {
      deleteSets: () => {
        mobx.runInAction(() => {
          store.deleteSets(store.mobile.selected_sets);
          store.mobile.selected_sets.clear();
          store.showNotification(Px.t('Pages removed'), 'success');
        });
      }
    });
  }

  openAutofillPanel(evt) {
    const mobile_store = this.data.store.mobile;
    mobile_store.animate(() => {
      mobile_store.setActiveTool('autofill-panel');
    });
  }

  // -------
  // Private
  // -------

  getEditableElements(type) {
    const selected_set = this.data.store.selected_set;
    return selected_set.getElementsByType(type).filter(element => element.is_editable_master_element);
  }

};

Px.Editor.MobileToolbar.icons = {
  image: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><polyline points="20.67 19.71 16.57 10.12 12.99 17.28 9.41 13.38 5.33 19.71" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"/><path d="M23.86,24.5H2.14a.64.64,0,0,1-.64-.64l0-21.7a.64.64,0,0,1,.64-.64l21.7,0a.64.64,0,0,1,.64.64V23.86A.64.64,0,0,1,23.86,24.5Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M1.5,19.71h23" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9.17,8.21A1.92,1.92,0,1,1,7.25,6.29,1.91,1.91,0,0,1,9.17,8.21Z" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"/></svg>',
  crop: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><line x1="2" y1="5" x2="21" y2="5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="21" y1="5" x2="21" y2="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="24" y1="21" x2="5" y2="21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="5" y1="21" x2="5" y2="2" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>',
  image_mask: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 23 23"><path fill="currentColor" stroke-width="0" stroke="none" d="M1.5,1.3c0.1,0,0.4,0.2,0.6,0.3c0.6,0.3,1.3,0.8,2.4,0.8c1.1,0,1.7-0.3,2.2-0.5C7.1,1.7,7.3,1.6,8,1.6 c0.6,0,0.9,0.1,1.3,0.3c0.5,0.2,1.1,0.5,2.2,0.5c1.1,0,1.7-0.3,2.2-0.5c0.4-0.2,0.7-0.3,1.3-0.3c0.6,0,0.9,0.1,1.3,0.3 c0.5,0.2,1.1,0.5,2.2,0.5c1,0,1.8-0.5,2.4-0.8c0.2-0.1,0.5-0.3,0.6-0.3c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.1 c0,0.1-0.2,0.4-0.3,0.6c-0.3,0.6-0.8,1.3-0.8,2.4c0,1.1,0.3,1.7,0.5,2.2c0.2,0.4,0.3,0.7,0.3,1.3c0,0.6-0.1,0.9-0.3,1.3 c-0.2,0.5-0.5,1.1-0.5,2.2c0,1.1,0.3,1.7,0.5,2.2c0.2,0.4,0.3,0.7,0.3,1.3c0,0.6-0.1,0.9-0.3,1.3c-0.2,0.5-0.5,1.1-0.5,2.2 c0,1,0.5,1.8,0.8,2.4c0.1,0.2,0.3,0.5,0.3,0.6c0,0,0,0-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.4-0.2-0.6-0.3 c-0.6-0.3-1.3-0.8-2.4-0.8c-1.1,0-1.7,0.3-2.2,0.5c-0.4,0.2-0.7,0.3-1.3,0.3c-0.6,0-0.9-0.1-1.3-0.3c-0.5-0.2-1.1-0.5-2.2-0.5 c-1.1,0-1.7,0.3-2.2,0.5c-0.4,0.2-0.7,0.3-1.3,0.3c-0.6,0-0.9-0.1-1.3-0.3c-0.5-0.2-1.1-0.5-2.2-0.5c-1,0-1.8,0.5-2.4,0.8 c-0.2,0.1-0.5,0.3-0.6,0.3c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.1-0.1-0.1c0-0.1,0.2-0.4,0.3-0.6c0.3-0.6,0.8-1.3,0.8-2.4 c0-1.1-0.3-1.7-0.5-2.2c-0.2-0.4-0.3-0.7-0.3-1.3c0-0.6,0.1-0.9,0.3-1.3c0.2-0.5,0.5-1.1,0.5-2.2c0-1.1-0.3-1.7-0.5-2.2 C1.7,8.9,1.6,8.6,1.6,8c0-0.5,0.2-0.8,0.4-1.2c0.3-0.6,0.8-1.3,0.4-2.7c-0.2-0.9-0.6-1.5-0.9-2C1.4,2,1.2,1.7,1.2,1.6 c0,0,0.1-0.1,0.2-0.2C1.5,1.3,1.5,1.3,1.5,1.3 M21.5,0.2c-0.8,0-1.6,1.1-3,1.1c-1.8,0-1.8-0.8-3.5-0.8c-1.8,0-1.8,0.8-3.5,0.8 C9.7,1.4,9.7,0.5,8,0.5c-1.8,0-1.8,0.8-3.5,0.8c-1.3,0-2.1-1.1-3-1.1C1.2,0.2,1,0.4,0.7,0.7c-1.2,1.2,0.2,1.7,0.7,3.7 C1.8,6.1,0.5,6.2,0.5,8c0,1.8,0.8,1.8,0.8,3.5c0,1.8-0.8,1.8-0.8,3.5c0,1.8,0.8,1.8,0.8,3.5c0,1.8-2,2.6-0.7,3.8 c0.3,0.3,0.6,0.4,0.8,0.4c0.8,0,1.6-1.1,3-1.1c1.8,0,1.8,0.8,3.5,0.8c1.8,0,1.8-0.8,3.5-0.8c1.8,0,1.8,0.8,3.5,0.8 c1.8,0,1.8-0.8,3.5-0.8c1.3,0,2.1,1.1,3,1.1c0.3,0,0.5-0.1,0.8-0.4c1.2-1.2-0.7-2.1-0.7-3.8s0.8-1.8,0.8-3.5 c0-1.8-0.8-1.8-0.8-3.5c0-1.8,0.8-1.8,0.8-3.5c0-1.8-0.8-1.8-0.8-3.5c0-1.8,2-2.6,0.7-3.8C22,0.4,21.8,0.2,21.5,0.2L21.5,0.2z"/><polyline fill="none" stroke="currentColor" stroke-width="1.2073" points="17.7,16.9 14.4,9.2 11.5,14.9 8.6,11.8 5.3,16.9"/><path fill="none" stroke="currentColor" stroke-width="1.2073" d="M2.2,16.9h18.5"/><path fill="none" stroke="currentColor" stroke-width="1.2073" d="M8.4,7.6c0,0.9-0.7,1.5-1.5,1.5S5.3,8.5,5.3,7.6c0-0.9,0.7-1.5,1.5-1.5C7.7,6.1,8.4,6.8,8.4,7.6 C8.4,7.6,8.4,7.6,8.4,7.6z"/><rect x="2" y="2" fill="none" stroke="currentColor" stroke-width="1.0383" width="19" height="19"/><path fill="currentColor" stroke="none" d="M1.7,1.7L1.7,1.7L1.7,1.7 M2.2,1.1h-1v1h1V1.1L2.2,1.1z"/><path fill="currentColor" stroke="none" d="M21.5,1.5L21.5,1.5L21.5,1.5L21.5,1.5L21.5,1.5 M22,1h-1v1h1V1L22,1z"/><polygon fill="currentColor" stroke="none" points="22,21 21,21 21,22 22,22 22,21"/><polygon fill="currentColor" stroke="none" points="2.2,21 1.2,21 1.2,22 2.2,22 2.2,21"/></svg>',
  font: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><polyline points="4.17 6.63 4.17 2 22.7 2 22.7 6.63" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.83"/><path d="M13.44,2V22.84" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.83"/><path d="M8.81,24h9.26" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.83"/></svg>',
  font_size: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><polyline points="7.98 7.25 7.98 3.12 24.5 3.12 24.5 7.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.62"/><path d="M16.24,3.11V21.7" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.62"/><path d="M12.11,22.74h8.26" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.62"/><polyline points="1.5 15.8 1.5 13.91 9.06 13.91 9.06 15.8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.62"/><path d="M5.28,13.91v8.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.62"/><path d="M3.39,22.89H7.17" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.62"/></svg>',
  alignment: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><line x1="4" y1="5" x2="22" y2="5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.35"/><line x1="6.45" y1="9.09" x2="19.55" y2="9.09" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.35"/><line x1="4" y1="13.18" x2="22" y2="13.18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.35"/><line x1="6.45" y1="17.27" x2="19.55" y2="17.27" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.35"/><line x1="4" y1="21.36" x2="22" y2="21.36" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.35"/></svg>',
  text: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M20.3,2.39h1.88a.31.31,0,0,1,.31.31V4.87a0,0,0,0,1,0,0H20a0,0,0,0,1,0,0V2.7a.31.31,0,0,1,.31-.31Z" transform="translate(8.79 -13.96) rotate(45)" stroke="currentColor" fill="currentColor" stroke-linecap="round" stroke-width="0.88"/><rect x="12.51" y="3.69" width="2.5" height="14.86" stroke-width="0.88" stroke="currentColor" fill="currentColor" stroke-linecap="round" transform="translate(11.89 -6.47) rotate(45)"/><polygon points="5.15 19.73 8.03 18.36 6.51 16.84 5.15 19.73" stroke="currentColor" fill="currentColor" stroke-linecap="round" stroke-width="0.71"/><line x1="2" y1="23" x2="24" y2="23" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>',
  duplicate: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M9.46,22a2,2,0,0,1-2-2V3.73H5a2,2,0,0,0-2,2V22.77a2,2,0,0,0,2,2H16.78a2,2,0,0,0,2-2V22Z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.31"/><path d="M22.66,5,19.22,1.58A2,2,0,0,0,17.83,1H9.46a2,2,0,0,0-2,2V20a2,2,0,0,0,2,2H21.27a2,2,0,0,0,2-2V6.41A2,2,0,0,0,22.66,5Z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.31"/><line x1="17.99" y1="1" x2="17.99" y2="6.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.31"/><line x1="23.24" y1="6.25" x2="17.99" y2="6.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.31"/></svg>',
  remove: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M20,5.5V22.65a.86.86,0,0,1-.85.85H6.85A.86.86,0,0,1,6,22.65V5.5H20M21.5,4H4.5V22.65A2.36,2.36,0,0,0,6.85,25h12.3a2.36,2.36,0,0,0,2.35-2.35V4Z" stroke="none" stroke-width="0" fill="currentColor"/><line x1="3.5" y1="4.5" x2="22.5" y2="4.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="10.5" y1="9" x2="10.5" y2="21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="15.5" y1="9" x2="15.5" y2="21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="8.75" y1="3.99" x2="10.49" y2="1.76" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="15.3" y1="1.75" x2="10.5" y2="1.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.47"/><line x1="17.24" y1="4.23" x2="15.5" y2="2" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>',
  quantity_controls: '<svg width="26px" height="26px" viewBox="0 0 26 26"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-1123.000000, -179.000000)" stroke="currentColor" stroke-width="1.5"><g transform="translate(1096.000000, 0.000000)"><g transform="translate(0.000000, 160.000000)"><g transform="translate(28.000000, 20.000000)"><polygon points="24 24 0 24 0 0 24 0"></polygon><path d="M6,9 L8,7 L8,18"></path><path d="M16,7 L16,13 M13,10 L19,10"></path><path d="M13,17 L19,17"></path></g></g></g></g></g></svg>',
}

Px.Editor.MobileToolbar.DeletePageSetsModal = class DeletePageSetsModal extends Px.Components.BaseModal {

  get title() {
    return Px.t('Really delete selected pages?');
  }

  get footer() {
    return Px.template`
      <button class="px-large px-secondary-color" data-onclick="cancel">
        ${Px.t('Cancel')}
      </button>
      <button class="px-large px-warning-color px-strong" data-onclick="deleteSets">
        ${Px.t('Delete')}
      </button>
    `;
  }

  get css_class() {
    return `${super.css_class} px-confirmation-modal`;
  }

  constructor(props) {
    super(props);
    this.close_on_background_click = false;
  }

  get dataProperties() {
    return {
      deleteSets: {required: true}
    }
  }

  // --------------
  // Event handlers
  // --------------

  cancel(evt) {
    this.destroy();
  }

  deleteSets(evt) {
    this.data.deleteSets();
    this.destroy();
  }

};
